import * as THREE from 'three';
import {
  CSS2DRenderer,
  CSS2DObject,
} from 'three/addons/renderers/CSS2DRenderer.js';
import {
  CSS3DRenderer,
  CSS3DSprite,
  CSS3DObject,
} from 'three/examples/jsm/renderers/CSS3DRenderer.js';

export function loaderModel (app) {
  return new Promise ((resolve, reject) => {
    let urls = [
      {
        type: 'glb',
        url: '/model/m1.glb',
        onLoad: object => {
          console.log (object);

          const div = document.createElement ('div');
          div.className = 'tag';
          div.innerText = '标签测试';
          div.style.color = 'deeppink';
          div.style.padding = '4px 8px';
          div.style.border = '1px solid deepskyblue';
          div.style.background = 'rgba(253, 8, 28, 0.5)';
          div.style.borderRadius = '5px';
          div.style.position = 'absolute';
          document.querySelector ('.screen').appendChild (div);
          const tag = new CSS3DSprite (div);
          tag.scale.set (0.05, 0.05, 0.05);
          tag.position.set (30, -30, -5);

          object.scene.children[0].children[1].add (tag);

          app.scene.add (object.scene);
          resolve (object);
        },
      },
    ];
    app.iterateLoad (urls, null, () => {});
    resolve ();
  });
}
